//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QINIU_SERVER } from '../../../config'
import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'
import { mapActions } from 'vuex'
import * as queryString from 'query-string'

export default {
  name: 'SportsTourCard',
  components: {

  },
  props: ['route', 'width'],
  data() {
    return {
      addressIcon,
      timeIcon,
      checkTalentRaiders: false,
      features: this.route.featureList,
    }
  },
  computed: {
    qiniuImage() {
      return `${QINIU_SERVER}${this.route.image}-m.cover.thumb.jpg`
    },
    linkBtn() {
      return this.route.routeType === 1 ? 'package-confirm-link' : 'custom-confirm-link'
    },
  },
  methods: {
    ...mapActions(['showToast']),
    routeTo() {
      const sid = queryString.parse(window.location.search).sid
      if (sid && sid !== 'undefined') {
        window.location.href = `/h5/sportsTourRouteIntroductionejs/${this.route.id}/${sid}`
      } else {
        window.location.href = `/h5/sportsTourRouteIntroductionejs/${this.route.id}`
      }
    },
    formattime(time) {
      const times = time.split('.')
      return `${times[1]}月${times[2]}日`
    },
    calcFeaturesWidth(features) {
      let result = features.reduce((acc, feature) => (
        // feature width = 10 + 12 * n
        acc += ((feature.length * 10) + 8)
      ), 0)
      // margin-left: 4px
      result += (4 * (features.length - 1))
      return result
    },
    regenerateFeatures(features, allowWidth) {
      const sliceFeatures = features.slice(0, features.length - 1)
      const sliceFeaturesWidth = this.calcFeaturesWidth(sliceFeatures)
      if (allowWidth > sliceFeaturesWidth) {
        this.features = sliceFeatures
      } else {
        // 递归调用裁剪features
        this.regenerateFeatures(sliceFeatures, allowWidth)
      }
    },
  },
  ready() {
    const element = this.$el
    const priceWidth = element.querySelector('.sports-tour-price') && element.querySelector('.sports-tour-price').offsetWidth
    const allowWidth = this.width - priceWidth
    const actualWidth = this.calcFeaturesWidth(this.route.featureList)
    // if the width of actual features is larger than expect width, regenerate features
    if (allowWidth < actualWidth) {
      this.regenerateFeatures(this.features, allowWidth)
    }
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/SportsTourCard.vue